module.exports = __webpack_public_path__ + "static/media/gpi.f75811d6.png";